/* global fetch */
import anonymize from 'ip-anonymize'

const URL = 'https://www.cloudflare.com/cdn-cgi/trace'

export default async () => {
  const response = await fetch(URL)
  if (!response.ok) throw new Error(`[${response.status}] ${response.statusText}`)

  const data = await response.text()
  const ip = data.match(/ip=\b(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})\b/)[1]

  return ip && anonymize(ip)
}



// WEBPACK FOOTER //
// ./src/utils/ip.js